import {RefObject, useEffect} from 'react';

/**
 * Run a callback function when a click outside a DOM node is detected
 *
 * @param {RefObject<HTMLElement>} ref
 * Reference to DOM node (tooltip/popover)
 *
 * @param {() => unknown} callback
 * Callback to call when outside click is detected
 */
export function useOutsideClick(
  ref: RefObject<HTMLElement>,
  callback: () => unknown,
  condition = true
): void {
  useEffect(() => {
    if (condition) {
      const handleClick = (event: MouseEvent) => {
        if (
          ref.current &&
          event.target instanceof HTMLElement &&
          !ref.current.contains(event.target)
        ) {
          callback();
        }
      };

      document.addEventListener('mousedown', handleClick);
      return () => document.removeEventListener('mousedown', handleClick);
    }
  }, [ref, condition]);
}
